// extracted by mini-css-extract-plugin
export default {"btnContainer":"gALhM4oDhWK_5oRbGw5n__btnContainer___","editFrom":"BW6BKSQbyBAEmKybaWnp__editFrom___","externalLink":"qDlYSo4rvda0_GHVhqK1__externalLink___"};